import { isAxiosError } from "axios";

export interface ApiError {
  status?: number;
  message?: string;
  reason?: string;
  data?: Record<string, unknown>;
  isNetworkError: boolean;
}

interface ApiErrorEnvelope {
  error?: {
    message?: string;
    data?: Record<string, unknown>;
  };
}

export function getApiError(error: unknown): ApiError {
  if (isAxiosError(error)) {
    const envelope = error.response?.data as ApiErrorEnvelope | undefined;
    const data = envelope?.error?.data;
    return {
      status: error.response?.status,
      message: envelope?.error?.message,
      reason: typeof data?.reason === "string" ? data.reason : undefined,
      data,
      isNetworkError: !error.response,
    };
  }
  return { isNetworkError: false };
}
